import { endpoints, routes } from './routes';
import { hosts } from './hosts';

export const configs = {
  endpoints,
  hosts,
  routes,
};
